import {
  type ApplicationConfig,
  provideZonelessChangeDetection,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import {
  provideRouter,
  withComponentInputBinding,
  withInMemoryScrolling,
  withViewTransitions,
} from '@angular/router';

import { appRoutes } from './app.routes';
import {
  provideClientHydration,
  withEventReplay,
  withIncrementalHydration,
} from '@angular/platform-browser';
import {
  provideHttpClient,
  withFetch,
  withInterceptors,
} from '@angular/common/http';
import {
  APP_INTERCEPTORS,
  provideApiConfiguration,
  provideAppTitleStrategy,
  provideCustomRouteReuse,
  provideScrollRestoration,
  provideSentryBrowser,
  provideSvgBrowserLoader,
  provideTicketWidgetLoader,
} from '@app/core';

export const appConfig: ApplicationConfig = {
  providers: [
    // Платформа и ядро
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),

    // Роутинг и рендеринг
    provideRouter(
      appRoutes,
      withComponentInputBinding(),
      withViewTransitions(),
      withInMemoryScrolling({
        anchorScrolling: 'enabled',
        scrollPositionRestoration: 'disabled',
      }),
    ),
    provideClientHydration(withEventReplay(), withIncrementalHydration()),
    provideScrollRestoration(),
    provideCustomRouteReuse(),
    provideAppTitleStrategy(),

    // Данные и сеть
    provideHttpClient(withFetch(), withInterceptors(APP_INTERCEPTORS)),
    provideSvgBrowserLoader(),

    // Интеграции приложения
    provideApiConfiguration(),
    provideSentryBrowser(),
    provideTicketWidgetLoader(),
  ],
};
